import { Brand, createBranded } from '@deltasierra/type-utilities';

export type LearnCommentId = Brand<number, 'LearnCommentId'>;
export const LearnCommentId = createBranded<LearnCommentId>();
